module.exports = "<!-- begin::Body -->\n<router-outlet></router-outlet>\n<!-- end:: Body -->\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/portalV2/main.component.html
// module id = ./src/app/portalV2/main.component.html
// module chunks = main